// extracted by mini-css-extract-plugin
export var productImage = "_vo-0";